import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import InputGroup from "./../../elements/InputGroup";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";

import bookclosure_taskstatus from "../../data/bookclosure_taskstatus.json";
import modules from "../../data/modules.json";
import FilterRow from "./FilterRow";

const BookClosureCommentsFilterModal = ({
  setBookClosureCommentsFilterModal,
  assignOptions,
  approveOptions,
  applyFiltersHandler,
}) => {
  const [assigneeId, setAssigneeId] = useState([]);
  const [approverId, setApproverId] = useState([]);
  const [createdBy, setCreatedBy] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [status, setStatus] = useState([]);
  const animatedComponents = makeAnimated();

  const applyFilter = () => {
    const filters = {
      ...(assigneeId && { assigneeID: assigneeId }),
      // ...(approverId && { approverID: approverId }),
      ...(createdBy && { createdBy: createdBy }),
      ...(status && { status: status }),
      ...(dueDate && { dueDate: dayjs(dueDate).format("DD-MM-YYYY") }),
    };
    applyFiltersHandler(filters);
  };

  const clearBasicFilters = () => {
    setAssigneeId(null);
    setApproverId(null);
    setDueDate(null);
    setStatus(null);
    setCreatedBy(null);
  };

  const statuses = [{label:"Unresolved",value:"unresolved"},{label:"Resolved",value:"resolved"},{label:"Closed",value:"closed"},{label:"Overdue",value:"overdue"}];
  return (
    <Modal
      width={"35%"}
      minHeight={"350px"}
      title="Filters"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          <label
            className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
            onClick={() => {
              clearBasicFilters();
            }}
          >
            Reset All
          </label>
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setBookClosureCommentsFilterModal(false);
            }}
            label="Cancel"
          />
          <span >
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Apply Filter"
              onClick={() => {
                applyFilter();
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <>
          <span className="input-label">Status</span>
          <Select
            placeholder="Select Status"
            name="status"
            value={statuses.filter(s => status.includes(s.value))}
            onChange={(selectedOptions) => {
              const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
              setStatus(values);
            }}
            options={statuses}
            className="w-100 mt-0"
            classNamePrefix="select"
            components={{
              ...animatedComponents,
              IndicatorSeparator: () => null,
              DropdownIndicator: CustomDropdownIndicator,
            }}
            styles={customStyles}
            isMulti
          />

          <span className="input-label mt-2">Assigned to</span>
          <Select
            placeholder="Select Assignee"
            name="assignee"
            // value={assigneeId}
            value={assignOptions.filter(s => assigneeId.includes(s.value))}
            // onChange={setAssigneeId}
            onChange={(selectedOptions) => {
              const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
              setAssigneeId(values);
            }}
            options={assignOptions}
            className="w-100 mt-0"
            classNamePrefix="select"
            components={{
              ...animatedComponents,
              IndicatorSeparator: () => null,
              DropdownIndicator: CustomDropdownIndicator,
            }}
            styles={customStyles}
            isMulti
          />

          <span className="input-label mt-2">Commented by</span>
          <Select
            placeholder="Select commented by"
            name="assignee"
            // value={createdBy}
            value={assignOptions.filter(s => createdBy.includes(s.value))}
            // onChange={setCreatedBy}
            onChange={(selectedOptions) => {
              const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
              setCreatedBy(values);
            }}
            options={assignOptions}
            className="w-100 mt-0"
            classNamePrefix="select"
            components={{
              ...animatedComponents,
              IndicatorSeparator: () => null,
              DropdownIndicator: CustomDropdownIndicator,
            }}
            styles={customStyles}
            isMulti
          />

          {/* <span className="input-label mt-2">Approver</span>
          <Select
            placeholder="Select Approver"
            name="approver"
            // value={approverId}
            value={approveOptions.filter(s => approverId.includes(s.value))}
            // onChange={setApproverId}
            onChange={(selectedOptions) => {
              const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
              setApproverId(values);
            }}
            options={approveOptions}
            className="w-100 mt-0 mb-2"
            classNamePrefix="select"
            components={{
              ...animatedComponents,
              IndicatorSeparator: () => null,
              DropdownIndicator: CustomDropdownIndicator,
            }}
            styles={customStyles}
            isMulti
          /> */}

          <InputGroup
            label="Due Date"
            inputs={[
              <>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker", "MobileDatePicker"]}
                  >
                    <MobileDatePicker
                      className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                      value={dueDate ? dayjs(dueDate) : null}
                      onChange={(value) => {
                        setDueDate(value);
                      }}
                      format="DD-MMM-YYYY"
                      slotProps={{
                        textField: {
                          InputProps: {
                            disableUnderline: true,
                          },
                          inputProps: {
                            placeholder: "DD-MM-YYYY",
                          },
                          sx: {
                            "& fieldset": {
                              border: "none",
                            },
                          },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <span className="icon">
                  <CalenderIcon className="vaMiddle" width={20} height={20} />
                </span>
              </>,
            ]}
          />
        </>
      </div>
    </Modal>
  );
};

export default BookClosureCommentsFilterModal;
